import { Icon } from 'components'
import * as S from './styles'
import { theme } from 'styles/theme/hav-theme'

export type EmptyContentProps = {
  icon?: React.ReactNode
  title?: string
  description?: string | JSX.Element
}

export const EmptyContent: React.FC<EmptyContentProps> = ({
  icon = <Icon icon="empty" color={theme.colors.neutral.high} size="50" />,
  title = 'Nenhum item encontrado.',
  description
}) => {
  return (
    <S.Wrapper>
      <S.Content>
        {icon}
        <S.Title>{title}</S.Title>
        {description && <S.Text>{description}</S.Text>}
      </S.Content>
    </S.Wrapper>
  )
}
